import { render, staticRenderFns } from "./TranshipmentNegotiations.vue?vue&type=template&id=dc789180"
import script from "./TranshipmentNegotiations.vue?vue&type=script&lang=js"
export * from "./TranshipmentNegotiations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports